import { toast } from "@replo/design-system/components/toast/Toast";

export const showSubscriptionUpdateSuccessToast = () => {
  return toast.success({ title: "Plan Updated Successfully" });
};
